/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Title_LeadInputs */

const en_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const es_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campo de práctica`)
};

const de_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const zh_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得梅因`)
};

const ar_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const fr_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const vi_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const sw_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const th_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const bs_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const ja_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const ko_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const pt_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const it_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const sv_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const nl_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const da_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const nb_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const fi_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const pl_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const ru_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const tr_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const hi_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const id_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const ms_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const cs_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const el_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const he_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const af_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

const hu_range_title_lead = /** @type {(inputs: Range_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines`)
};

/**
* | output |
* | --- |
* | "Des Moines" |
*
* @param {Range_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_title_lead = /** @type {((inputs?: Range_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_title_lead(inputs)
	if (locale === "de") return de_range_title_lead(inputs)
	if (locale === "zh") return zh_range_title_lead(inputs)
	if (locale === "ar") return ar_range_title_lead(inputs)
	if (locale === "fr") return fr_range_title_lead(inputs)
	if (locale === "vi") return vi_range_title_lead(inputs)
	if (locale === "sw") return sw_range_title_lead(inputs)
	if (locale === "th") return th_range_title_lead(inputs)
	if (locale === "bs") return bs_range_title_lead(inputs)
	if (locale === "ja") return ja_range_title_lead(inputs)
	if (locale === "ko") return ko_range_title_lead(inputs)
	if (locale === "pt") return pt_range_title_lead(inputs)
	if (locale === "it") return it_range_title_lead(inputs)
	if (locale === "sv") return sv_range_title_lead(inputs)
	if (locale === "nl") return nl_range_title_lead(inputs)
	if (locale === "da") return da_range_title_lead(inputs)
	if (locale === "nb") return nb_range_title_lead(inputs)
	if (locale === "fi") return fi_range_title_lead(inputs)
	if (locale === "pl") return pl_range_title_lead(inputs)
	if (locale === "ru") return ru_range_title_lead(inputs)
	if (locale === "tr") return tr_range_title_lead(inputs)
	if (locale === "hi") return hi_range_title_lead(inputs)
	if (locale === "id") return id_range_title_lead(inputs)
	if (locale === "ms") return ms_range_title_lead(inputs)
	if (locale === "cs") return cs_range_title_lead(inputs)
	if (locale === "el") return el_range_title_lead(inputs)
	if (locale === "he") return he_range_title_lead(inputs)
	if (locale === "af") return af_range_title_lead(inputs)
	if (locale === "hu") return hu_range_title_lead(inputs)
	return en_range_title_lead(inputs)
});